import styled from 'styled-components';

export const SVG = styled.svg`
  display: block;
  transform: translate3d(0, 0, 0);
`;
